/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepartmentReportControllerGetDepartmentsReport200ResponseData } from './departmentReportControllerGetDepartmentsReport200ResponseData';


export interface UserTenantPermissionControllerGetPermissions200Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    data?: DepartmentReportControllerGetDepartmentsReport200ResponseData;
}

